
import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface MobileHeaderProps {
  onOpenSidebar: () => void;
  onLogout: () => void;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ onOpenSidebar, onLogout }) => {
  return (
    <header className="md:hidden flex items-center justify-between p-4 border-b">
      <Button 
        variant="ghost" 
        size="icon"
        onClick={onOpenSidebar}
      >
        <Menu className="h-5 w-5" />
      </Button>
      <Link to="/" className="flex items-center">
        <img 
          src="/lovable-uploads/15842cb5-3179-4432-90aa-2bb07c58715c.png" 
          alt="Site Logo" 
          className="h-auto w-25" 
          style={{ width: '25px' }}
        />
      </Link>
      <div className="flex items-center">
        <Button variant="ghost" size="icon" onClick={onLogout}>
          <LogOut className="h-5 w-5" />
        </Button>
      </div>
    </header>
  );
};

export default MobileHeader;
